<template>
    <div
        class="ExpandableItem"
        :class="{ 'ExpandableItem--disabled': disabled }"
        @click="!disabled && $emit('click', $event)"
    >
        <slot>
            <EidIcon v-if="icon" class="ExpandableItem__icon" :icon-src="icon" :icon-props="iconProps" />
            <span class="ExpandableItem__label">{{ label }}</span>
        </slot>
    </div>
</template>

<style lang="scss">
    .ExpandableItem {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 12px 16px;
        font-size: 14px;
        cursor: pointer;
        border-radius: 8.75px;

        &:hover:not(&--disabled) {
            background-color: var(--eidQualityBlack-10);
            color: var(--eidQualityBlack);
        }

        &--disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }

        &__icon {
            flex-shrink: 0;
            width: 1rem;
            height: 1rem;

            svg {
                width: 1rem;
                height: 1rem;
            }
        }
    }
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { EidIconFontAwesomeProps } from '@evidentid/dashboard-commons/components/EidIcon/types';

    export default defineComponent({
        name: 'ExpandableItem',
        components: { EidIcon },
        props: {
            label: {
                type: String as PropType<string>,
                required: true,
            },
            icon: {
                type: [ String, Object ] as PropType<string | IconDefinition | null>,
                default: null,
            },
            iconProps: {
                type: Object as PropType<EidIconFontAwesomeProps>,
                default: (): EidIconFontAwesomeProps => ({}),
            },
            disabled: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
        emits: [ 'click' ],
    });
</script>
